module.exports = __webpack_public_path__ + "static/media/freqs.b10cc10a.PNG";